import { AlertServiceProvider } from '../alert-service/alert-service';
import { CodePush } from '@ionic-native/code-push';
import { CodePushServiceProvider } from '../code-push-service/code-push-service';
import { ConfigServiceProvider } from '../config-service/config-service';
import { Device } from '@ionic-native/device';
import { ENVIRONMENT } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StorageServiceProvider } from '../storage-service/storage-service';
import { TextServiceProvider } from '../text-service/text-service';

@Injectable()
export class ApplicationUpdateServiceProvider {
  private _isDev: boolean = (<any>window)['IonicDevServer'] != undefined;

  constructor(
    public textService: TextServiceProvider,
    private alertService: AlertServiceProvider,
    private codePush: CodePush,
    private codePushService: CodePushServiceProvider,
    private configService: ConfigServiceProvider,
    private device: Device,
    private http: HttpClient,
    private plt: Platform,
    private storageService: StorageServiceProvider,
  ) {}

  tryToUpdate() {
    return new Promise((resolve, reject) => {
      if (this._isDev || ENVIRONMENT.versionUrl == 'dummy') {
        resolve('indev');
        return;
      }

      this.checkVersion()
        .then((isVersionCurrent) => {
          if (isVersionCurrent) {
            console.log('PLATFORM ', this.plt);
            if (this.plt && this.plt.is('cordova')) {
              this.codePushService
                .checkAndUpdate()
                .then((res) => {
                  if (res === 'installationSuccess') {
                    this.codePush.restartApplication();
                  }
                  resolve('restart');
                })
                .catch(() => this.alertService.showNoConnAlert());
            }
          } else {
            this.alertService.showUpdateAlert(() => {
              this.getNewerVersion();
              resolve('apk-update');
            });
          }
        })
        .catch((reason) => reject(reason));
    });
  }

  checkVersion() {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.configService.getConfig('versionUrl'))
        .toPromise()
        .then((response: any) => {
          let newestVersion = this.configService.getConfig('version');

          if (this.plt.is('ios')) {
            newestVersion = response.ios.version;
          } else if (this.plt.is('android')) {
            newestVersion = response.android.version;
          }

          let currentVersion = this.configService.getConfig('version');

          resolve(newestVersion === currentVersion);
        })
        .catch((err) => reject(err));
    });
  }

  getNewerVersion() {
    this.http
      .get(this.configService.getConfig('versionUrl'))
      .toPromise()
      .then((response: any) => {
        let newestVersion = null;

        if (this.device.platform === 'iOS') {
          newestVersion = response.ios.updateUrl;
          window.open(newestVersion, '_system');
          window.open(newestVersion, '_blank');
          window.open(newestVersion, '_self');
        } else if (this.plt.is('android')) {
          newestVersion = response.android.updateUrl;
          window.open(newestVersion, '_system');
          this.plt.exitApp();
        }
      })
      .catch(() => {
        this.alertService.showNoConnAlert(() => {});
      });
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/application-update-service/application-update-service.ts